/**
 * JsonEditor Component
 * Simple JSON editing with syntax highlighting via textarea
 */

import React from 'react';
import './JsonEditor.scss';

interface JsonEditorProps {
  value: string;
  onChange: (value: string) => void;
  readOnly?: boolean;
}

export const JsonEditor: React.FC<JsonEditorProps> = ({
  value,
  onChange,
  readOnly = false,
}) => {
  return (
    <div className="json-editor">
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        readOnly={readOnly}
        spellCheck={false}
        className="json-textarea"
      />
    </div>
  );
};

export default JsonEditor;


